import React from 'react';
import OnboardingLayout from './OnboardingLayout';
import OnboardingStep4 from './step4';

export default class OnboardingStep4Page extends React.Component {
    render() {
        return (
            <OnboardingLayout currentStep={4} totalSteps={5}>
                <OnboardingStep4 />
            </OnboardingLayout>
        );
    }
}
